import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dropdown', 'trigger'];

  connect() {
    // Bind the hide method to this instance for event listeners
    this.hideDropdown = this.hideDropdown.bind(this);
  }

  // Handle click events to toggle dropdown
  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const trigger = event.currentTarget;
    const dropdownId = trigger.dataset.dropdown;
    const dropdown = document.getElementById(dropdownId);

    if (dropdown) {
      const isCurrentlyOpen = !dropdown.classList.contains('hidden');

      if (isCurrentlyOpen) {
        // Close the dropdown if it's currently open
        this.hideAllDropdowns();
      } else {
        // Hide all other dropdowns first, then show this one
        this.hideAllDropdowns();
        this.showDropdown(event);
      }
    }
  }

  showDropdown(event) {
    const trigger = event.currentTarget;
    const dropdownId = trigger.dataset.dropdown;
    const dropdown = document.getElementById(dropdownId);

    if (dropdown) {
      dropdown.classList.remove('hidden');
      trigger.setAttribute('aria-expanded', 'true');

      // Add click outside listener
      setTimeout(() => {
        document.addEventListener('click', this.hideDropdown);
      }, 0);
    }
  }

  hideDropdown(event) {
    // If clicking inside a dropdown or on a trigger, don't close it
    if (event && (event.target.closest('[data-dropdown-content]') || event.target.closest('[data-dropdown]'))) {
      return;
    }

    this.hideAllDropdowns();
  }

  hideAllDropdowns() {
    // Hide all dropdowns
    const allDropdowns = document.querySelectorAll('[data-dropdown-content]');
    const allTriggers = document.querySelectorAll('[data-dropdown]');

    allDropdowns.forEach((dropdown) => dropdown.classList.add('hidden'));
    allTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));

    // Remove click listener
    document.removeEventListener('click', this.hideDropdown);
  }
}
